// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-internet-container, .loading-failed-container {
  padding: 15px;
  height: calc(100% - 30px);
  width: calc(100% - 30px);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.no-internet-container p, .loading-failed-container p {
  margin-top: 10px;
  text-align: center;
  font-weight: bold;
  font-size: 1em;
}
.no-internet-container img, .loading-failed-container img {
  height: 80px;
  width: 80px;
}
.no-internet-container .mat-mdc-raised-button, .loading-failed-container .mat-mdc-raised-button {
  border-radius: 0;
}

.data-container .title {
  padding: 0 10px;
}
.data-container .title p {
  font-size: 0.9em;
  font-weight: bold;
  padding-bottom: 5px;
  border-bottom: solid 1px black;
}
.data-container .summary {
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.data-container .summary p {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.data-container .summary p.personal-data {
  font-size: 0.9em;
  font-weight: bold;
  font-size: 0.85em;
  font-weight: bold;
}
.data-container .summary p.department-country, .data-container .summary p.department-city {
  font-size: 0.8em;
  font-weight: bold;
  color: grey;
  margin-top: 5px;
}
.data-container .qr-code {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.data-container .qr-code .title {
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 3px;
  font-size: 0.85em;
  font-weight: bold;
}
.data-container .qr-code img {
  width: 70%;
  max-width: 300px;
  margin: 0 auto;
}
.data-container .qr-code .hint {
  margin: 0 auto;
  margin-top: 5px;
  font-size: 0.8em;
  font-weight: bold;
  text-align: center;
  color: grey;
  width: 70%;
}
.data-container .status {
  padding: 0 10px;
  margin-top: 10px;
}
.data-container .status .icon {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  margin: 10px auto;
  height: 150px;
  width: 150px;
}
.data-container .status .icon.complete {
  background-image: url('assets/images/complete.png');
}
.data-container .status .icon.ready {
  background-image: url('assets/images/ready.png');
}
.data-container .status .icon.canceled {
  background-image: url('assets/images/canceled.png');
}
.data-container .status .icon.shipping {
  background-image: url('assets/images/shipped.png');
}
.data-container .status .icon.unknown {
  background-image: url('assets/images/question.png');
}
.data-container .status .progress {
  margin: 10px;
  display: grid;
}
.data-container .status .progress .wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column: 1;
  grid-row: 1;
}
.data-container .status .progress .wrapper ::ng-deep .mat-mdc-progress-spinner.background circle {
  stroke: #ccc;
}
.data-container .status .progress .wrapper .percent {
  font-size: 2em;
}
.data-container .status p {
  font-size: 1em;
  text-align: center;
  margin: 5px auto;
}
.data-container .status p span {
  font-weight: bold;
  margin-left: 5px;
}
.data-container .status p.title {
  font-weight: bold;
}
.data-container .actions {
  padding: 0 10px;
  margin-bottom: 20px;
}
.data-container .actions .section-title {
  margin: 0;
  margin-top: 30px;
  padding-bottom: 5px;
  font-size: 1em;
  font-weight: bold;
  color: #26a69a;
  border-bottom: solid 1px black;
}
.data-container .actions .mat-mdc-button.action-button {
  width: 100%;
  border-bottom: solid 1px black;
  border-radius: 0;
  padding: 0;
  justify-content: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/app/view/page/request-preview/request-preview.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,yBAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;AACJ;AAAI;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAER;AAAI;EACI,YAAA;EACA,WAAA;AAER;AAAI;EACI,gBAAA;AAER;;AAEI;EACI,eAAA;AACR;AAAQ;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;AAEZ;AACI;EACI,eAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACR;AAAQ;EACI,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAEZ;AADY;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AAGhB;AADY;EACI,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AAGhB;AACI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AACR;AAAQ;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AAEZ;AAAQ;EACI,UAAA;EACA,gBAAA;EACA,cAAA;AAEZ;AAAQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAEZ;AACI;EACI,eAAA;EACA,gBAAA;AACR;AAAQ;EACI,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,YAAA;AAEZ;AADY;EAAa,mDAAA;AAIzB;AAHY;EAAU,gDAAA;AAMtB;AALY;EAAa,mDAAA;AAQzB;AAPY;EAAa,kDAAA;AAUzB;AATY;EAAY,mDAAA;AAYxB;AAVQ;EACI,YAAA;EACA,aAAA;AAYZ;AAXY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;AAahB;AAZgB;EACI,YAAA;AAcpB;AAZgB;EACI,cAAA;AAcpB;AAVQ;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;AAYZ;AAXY;EACI,iBAAA;EACA,gBAAA;AAahB;AAXY;EACI,iBAAA;AAahB;AATI;EACI,eAAA;EACA,mBAAA;AAWR;AAVQ;EACI,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,8BAAA;AAYZ;AAVQ;EACI,WAAA;EACA,8BAAA;EACA,gBAAA;EACA,UAAA;EACA,2BAAA;AAYZ","sourcesContent":[".no-internet-container, .loading-failed-container {\n    padding: 15px;\n    height: calc(100% - 30px);\n    width: calc(100% - 30px);\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    p {\n        margin-top: 10px;\n        text-align: center;\n        font-weight: bold;\n        font-size: 1em;\n    }\n    img {\n        height: 80px;\n        width: 80px;\n    }\n    .mat-mdc-raised-button {\n        border-radius: 0;\n    }\n}\n.data-container {\n    .title {\n        padding: 0 10px;\n        p {\n            font-size: 0.9em;\n            font-weight: bold;\n            padding-bottom: 5px;\n            border-bottom: solid 1px black;\n        }\n    }\n    .summary {\n        padding: 0 10px;\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n        p {\n            margin: 0;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            &.personal-data {\n                font-size: 0.9em;\n                font-weight: bold;\n                font-size: 0.85em;\n                font-weight: bold;\n            }\n            &.department-country, &.department-city {\n                font-size: 0.8em;\n                font-weight: bold;\n                color: grey;\n                margin-top: 5px;\n            }\n        }\n    }\n    .qr-code {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        .title {\n            margin: 0 auto;\n            margin-top: 10px;\n            margin-bottom: 3px;\n            font-size: 0.85em;\n            font-weight: bold;\n        }\n        img {\n            width: 70%;\n            max-width: 300px;\n            margin: 0 auto;\n        }\n        .hint {\n            margin: 0 auto;\n            margin-top: 5px;\n            font-size: 0.80em;\n            font-weight: bold;\n            text-align: center;\n            color: grey;\n            width: 70%;\n        }\n    }\n    .status {\n        padding: 0 10px;\n        margin-top: 10px;\n        .icon {\n            background-repeat: no-repeat;\n            background-position: center;\n            background-size: cover;\n            margin: 10px auto;\n            height: 150px;\n            width: 150px;\n            &.complete { background-image: url('^assets/images/complete.png'); }\n            &.ready { background-image: url('^assets/images/ready.png'); }\n            &.canceled { background-image: url('^assets/images/canceled.png'); }\n            &.shipping { background-image: url('^assets/images/shipped.png'); }\n            &.unknown { background-image: url('^assets/images/question.png'); }\n        }\n        .progress {\n            margin: 10px;\n            display: grid;\n            .wrapper {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                grid-column: 1;\n                grid-row: 1;\n                ::ng-deep .mat-mdc-progress-spinner.background circle {\n                    stroke: #ccc;\n                }\n                .percent {\n                    font-size: 2em;\n                }\n            }\n        }\n        p {\n            font-size: 1.0em;\n            text-align: center;\n            margin: 5px auto;\n            span {\n                font-weight: bold;\n                margin-left: 5px;\n            }\n            &.title {\n                font-weight: bold;\n            }\n        }\n    }\n    .actions {\n        padding: 0 10px;\n        margin-bottom: 20px;\n        .section-title {\n            margin: 0;\n            margin-top: 30px;\n            padding-bottom: 5px;\n            font-size: 1.0em;\n            font-weight: bold;\n            color: #26a69a;\n            border-bottom: solid 1px black;\n        }\n        .mat-mdc-button.action-button {\n            width: 100%;\n            border-bottom: solid 1px black;\n            border-radius: 0;\n            padding: 0;\n            justify-content: flex-start;\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
